'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _ui = require('../../../../modules/ui');

var UI = _interopRequireWildcard(_ui);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ContextProvider = (_temp = _class = function (_Component) {
  _inherits(ContextProvider, _Component);

  function ContextProvider() {
    _classCallCheck(this, ContextProvider);

    return _possibleConstructorReturn(this, (ContextProvider.__proto__ || Object.getPrototypeOf(ContextProvider)).apply(this, arguments));
  }

  _createClass(ContextProvider, [{
    key: 'render',
    // componentWillMount() {
    //   // const {
    //   //   query,
    //   //   ...other
    //   // } = this.context;
    //   // this.newContext = {
    //   //   query: {
    //   //     ...query,
    //   //     ...this.prepareQuery(),
    //   //   },
    //   //   ...other
    //   // }
    //   Object.assign(this.context, {
    //     ...UI,
    //   });
    // }
    value: function render() {
      var children = this.props.children;
      var query = this.context.query;
      Object.assign(this.context, _extends({
        query: query ? Object.assign(query, _extends({}, this.prepareQuery())) : query
      }, UI));
      return _react2.default.createElement(_context2.default.Provider, {
        value: this.context
      }, children || null); // return children || null;
    }
  }, {
    key: 'prepareQuery',
    value: function prepareQuery() {
      return {// ...this.prepareUserQuery(),
      };
    } // prepareUserQuery() {
    //   const {
    //     queryFragments,
    //   } = this.context;
    //   const {
    //     UserNoNestingFragment,
    //     BatchPayloadNoNestingFragment,
    //     ResetPasswordNoNestingFragment,
    //   } = queryFragments;
    //   const usersConnection = `
    //     query usersConnection (
    //       $where: UserWhereInput
    //       $orderBy: UserOrderByInput
    //       $skip: Int
    //       $after: String
    //       $before: String
    //       $first: Int
    //       $last: Int
    //     ){
    //       objectsConnection: usersConnection (
    //         where: $where
    //         orderBy: $orderBy
    //         skip: $skip
    //         after: $after
    //         before: $before
    //         first: $first
    //         last: $last
    //       ){
    //         aggregate{
    //           count
    //         }
    //         edges{
    //           node{
    //             ...UserNoNesting
    //           }
    //         }
    //       }
    //     }
    //     ${UserNoNestingFragment}
    //   `;
    //   const users = `
    //     query users (
    //       $where: UserWhereInput
    //       $orderBy: UserOrderByInput
    //       $skip: Int
    //       $after: String
    //       $before: String
    //       $first: Int
    //       $last: Int
    //     ){
    //       objects: users (
    //         where: $where
    //         orderBy: $orderBy
    //         skip: $skip
    //         after: $after
    //         before: $before
    //         first: $first
    //         last: $last
    //       ){
    //         ...UserNoNesting
    //       }
    //     }
    //     ${UserNoNestingFragment}
    //   `;
    //   const user = `
    //     query user (
    //       $where: UserWhereUniqueInput!
    //     ){
    //       object: user (
    //         where: $where
    //       ){
    //         ...UserNoNesting
    //       }
    //     }
    //     ${UserNoNestingFragment}
    //   `;
    //   const createUserProcessor = `
    //     mutation createUserProcessor(
    //       $data: UserCreateInput!
    //     ) {
    //       response: createUserProcessor(
    //         data: $data
    //       ){
    //         success
    //         message
    //         errors{
    //           key
    //           message
    //         }
    //         data{
    //           ...UserNoNesting
    //         }
    //       }
    //     }
    //     ${UserNoNestingFragment}
    //   `;
    //   const updateUserProcessor = `
    //     mutation updateUserProcessor(
    //       $data: UserUpdateInput!
    //       $where: UserWhereUniqueInput
    //     ) {
    //       response: updateUserProcessor(
    //         data: $data
    //         where: $where
    //       ){
    //         success
    //         message
    //         errors{
    //           key
    //           message
    //         }
    //         data{
    //           ...UserNoNesting
    //         }
    //       }
    //     }
    //     ${UserNoNestingFragment}
    //   `;
    //   const signup = `
    //     mutation signup(
    //       $data: UserCreateInput!
    //     ) {
    //       response: signup(
    //         data: $data
    //       ){
    //         success
    //         message
    //         errors{
    //           key
    //           message
    //         }
    //         token
    //         data{
    //           ...UserNoNesting
    //         }
    //       }
    //     }
    //     ${UserNoNestingFragment}
    //   `;
    //   const signin = `
    //     mutation signin(
    //       $data: SigninDataInput!
    //       $where: UserWhereUniqueInput!
    //     ) {
    //       response: signin(
    //         data: $data
    //         where: $where
    //       ){
    //         success
    //         message
    //         errors{
    //           key
    //           message
    //         }
    //         token
    //         data{
    //           ...UserNoNesting
    //         }
    //       }
    //     }
    //     ${UserNoNestingFragment}
    //   `;
    //   const deleteUser = `
    //     mutation deleteUser (
    //       $where: UserWhereUniqueInput!
    //     ){
    //       deleteUser(
    //         where: $where
    //       ){
    //         ...UserNoNesting
    //       }
    //     }
    //     ${UserNoNestingFragment}
    //   `;
    //   const deleteManyUsers = `
    //     mutation deleteManyUsers (
    //       $where: UserWhereInput
    //     ){
    //       deleteManyUsers(
    //         where: $where
    //       ){
    //         ...BatchPayloadNoNesting
    //       }
    //     }
    //     ${BatchPayloadNoNestingFragment}
    //   `;
    //   const createResetPasswordProcessor = `
    //     mutation createResetPasswordProcessor(
    //       $data: ResetPasswordCreateInput!
    //     ) {
    //       response: createResetPasswordProcessor(
    //         data: $data
    //       ){
    //         success
    //         message
    //         errors{
    //           key
    //           message
    //         }
    //         data{
    //           ...ResetPasswordNoNesting
    //         }
    //       }
    //     }
    //     ${ResetPasswordNoNestingFragment}
    //   `;
    //   const resetPasswordProcessor = `
    //     mutation resetPasswordProcessor(
    //       $data: ResetPasswordInput!
    //       $where: UserWhereUniqueInput!
    //     ) {
    //       response: resetPasswordProcessor(
    //         data: $data
    //         where: $where
    //       ){
    //         success
    //         message
    //         errors{
    //           key
    //           message
    //         }
    //         token
    //         data{
    //           ...UserNoNesting
    //         }
    //       }
    //     }
    //     ${UserNoNestingFragment}
    //   `;
    //   return {
    //     usersConnection,
    //     users,
    //     user,
    //     createUserProcessor,
    //     updateUserProcessor,
    //     deleteUser,
    //     signup,
    //     signin,
    //     deleteManyUsers,
    //     createResetPasswordProcessor,
    //     resetPasswordProcessor,
    //   }
    // }

  }]);

  return ContextProvider;
}(_react.Component), _class.contextType = _context2.default, _temp);
exports.default = ContextProvider;
module.exports = exports['default'];